import { app } from '../coreConfig'
import { getDownloadURL, getStorage, ref } from 'firebase/storage'

export async function getDownloadUrl(bucketName, path) {
  const storage = getStorage(app, `gs://${bucketName}`)
  return await getDownloadURL(ref(storage, path))
}
